import React from 'react'
import { AccordionCard } from 'components/AccordionCard'
import { InfoTable } from 'components/InfoTable'
import { useJurisdictionDetailContextValue } from '../context/JurisdictionDetailProvider'
import { Globe, Hash, MapPin, Map } from 'lucide-react'
import { Text } from '@workwhile/ui'

const LEVEL_LABELS: Record<string, string> = {
  federal: 'Federal',
  state: 'State',
  county: 'County',
  place: 'Place (Incorporated)',
}

export const JurisdictionInfoCard = () => {
  const {
    state: { level, stateCode, countyFips, placeGeoid },
  } = useJurisdictionDetailContextValue()

  return (
    <AccordionCard
      title={
        <Text fontSize={2} color="lightText">
          Details
        </Text>
      }
      size="small"
    >
      <InfoTable>
        <InfoTable.Row
          icon={<Globe size={14} />}
          label="Level"
          value={LEVEL_LABELS[level] ?? level}
        />
        {stateCode ? (
          <InfoTable.Row
            icon={<Map size={14} />}
            label="State"
            value={stateCode}
          />
        ) : null}
        {countyFips ? (
          <InfoTable.Row
            icon={<Hash size={14} />}
            label="County FIPS"
            value={countyFips}
          />
        ) : null}
        {placeGeoid ? (
          <InfoTable.Row
            icon={<MapPin size={14} />}
            label="Place GEOID"
            value={placeGeoid}
          />
        ) : null}
      </InfoTable>
    </AccordionCard>
  )
}
